import { logout } from "$/lib/auth"
import { Button } from "@repo/ui/components/ui/button"
import { Body, H1 } from "@repo/ui/components/ui/typography"
import { createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute("/(auth)/not-admin")({
  component: RouteComponent,
})

function RouteComponent() {
  const handleLogout = async () => {
    await logout()
    window.location.assign("/login")
  }

  return (
    <div className="flex min-h-svh flex-col items-center justify-center gap-4 p-6 text-center">
      <H1 weight="bold" className="text-3xl">
        Ingen behörighet
      </H1>
      <Body className="text-muted-foreground">
        Kontot ni är inloggade med är inte ett administratörskonto.
      </Body>
      <Button onClick={handleLogout}>Logga ut</Button>
    </div>
  )
}
